<template>
    <div class="favorite-container">
        <div class="text-center nopads">
            <h4 class="cut-text wrap-text" style="color: #7FC000;">{{ contract ? contract.name : ' '}}</h4>
            <span class="item-detail-title nopads" style="color: #9e9d9d; font-size: .9em">{{ contract ? contract.customer.name : ' '}}</span>
        </div>
        <!-- DATA PART -->
        <div style="height: 10em; padding-top: 1em; padding-bottom: 1em">
            <span v-if="loading">{{ $t('common.loading')}}</span>
            <div v-else-if="contract" class="text-center">
                <span class="favorite-content-title">{{ $t('favorites.distance_yesterday')}}</span>
                <span class="favorite-content-text">{{ totalDistance }} ({{ workDistance }}) km</span>
                <span class="favorite-content-title">{{ $t('favorites.cost_yesterday')}}</span>
                <span class="favorite-content-text">{{ cost }} {{ currency }}</span>
            </div>
        </div>
        <!-- BOTTOM BUTTON ROW -->
        <div class="nopads text-center">
            <div v-if="!loading && contract" class="row favorite-buttons" ref="shortcuts">
                <div ref="cInfo" class="col" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('favorites.contract_info')"><font-awesome-icon :id="contract.id + 'info'" class="favorite-button" icon="info-circle" @click="$emit('shortcutClick', 'contracts', {item: contract})"/></div>
                <div ref="cReport" class="col" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('daily_summary.title')"><font-awesome-icon :id="contract.id + 'report'" class="favorite-button" icon="tasks" @click="$emit('shortcutClick', 'tripReports', {item: contract.id})"/></div>
                <div v-if="contract.ely_contract" ref="cElyReport" class="col" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('contracts.ely_reports')"><font-awesome-icon :id="contract.id + 'report'" class="favorite-button" icon="newspaper" @click="$emit('shortcutClick', 'contracts', { item: contract, tab: 5})"/></div>
                <div ref="cTrips" class="col" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('menu.fleet_trips')"><font-awesome-icon :id="contract.id + 'route'" class="favorite-button" icon="route" @click="$emit('shortcutClick', 'searchTrips', {item: contract})"/></div>
                <div ref="cDiary" class="col" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('contracts.external.work_diary')"><font-awesome-icon :id="contract.id + 'diary'" class="favorite-button" icon="clock" @click="$emit('shortcutClick', 'workDiary', {item: contract})"/></div>
                <div ref="cRemove" class="col" data-bs-toggle="tooltip" data-bs-placement="top" :title="$t('favorites.remove')"><font-awesome-icon :id="contract.id + 'remove'" class="favorite-button" icon="trash" @click="handleRemove"/></div>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../mixins/RestApiMixin'
import {timeUtils} from "@/components/mixins/TimeUtils";
import { Tooltip } from 'bootstrap';

export default {
    name: 'ContractFavorite',
    mixins: [restApi, timeUtils],
    data: function () {
        return {
            contract: null,
            totalDistance: "-",
            workDistance: "-",
            cost: "-",
            loading: false,
            error: false
        }
    },
    props: {
        id: {
            type: Number,
            default: null
        }
    },
    computed: {
        currency() {
            return import.meta.env.VITE_APP_CURRENCY || '€'
        }
    },
    watch: {
        id: function() {
            this.contract = null
            this.fetchContract()
        }
    },
    mounted: function () {
        this.fetchContract()
    },

    beforeUnmount() {
        this.disposeTooltips()
    },

    methods: {

        handleRemove() {
            if (this.$refs.cRemove) {
                const tip = Tooltip.getInstance(this.$refs.cRemove);
                if (tip) tip.dispose();
            }
            this.$emit("remove");
        },

        disposeTooltips() {
            [this.$refs.cInfo, this.$refs.cReport, this.$refs.cElyReport, this.$refs.cTrips, this.$refs.cDiary, this.$refs.cRemove]
                .forEach(ref => { if (ref) Tooltip.getInstance(ref)?.dispose() })
        },

        initTooltips() {
            this.disposeTooltips()
            ;[this.$refs.cInfo, this.$refs.cReport, this.$refs.cElyReport, this.$refs.cTrips, this.$refs.cDiary, this.$refs.cRemove]
                .forEach(ref => { if (ref) new Tooltip(ref) })
        },

        fetchContract: function () {
            this.restFetchParams(this.contractUrl, {id: this.id}, this.handleResponse)
        },

        handleResponse: function (response) {
            if (response && response.data && response.data.length === 1) {
                this.contract = response.data[0]
                this.fetchKeyFigures()
            } else {
                this.error = true
            }
            this.loading = false
        },

        fetchKeyFigures: function () {
            let params = {
                contract: this.id,
                from: this.getYesterday(),
                to: this.getYesterday()
            }
            this.restFetchParams(this.contractDailyTripSummaryFiguresUrl, params, this.parseFigures)
        },

        parseFigures(response) {
            if (response && response.data) {
                this.cost = response.data.cost
                this.totalDistance = parseFloat(response.data.work_distance) + parseFloat(response.data.resettle_distance)
                this.totalDistance = this.totalDistance.toFixed(1)
                this.workDistance = parseFloat(response.data.work_distance).toFixed(1)
            }
            this.$nextTick(() => this.initTooltips())
        }

    }
}
</script>
